import {
  DayFormatEnum,
  HourFormatEnum,
  MonthFormatEnum,
  NotationOrderEnum,
  YearFormatEnum,
} from '@ulysses-inc/harami_api_client'

export const yearFormats: readonly YearFormatEnum[] = [
  YearFormatEnum.YYYY,
  YearFormatEnum.YY,
  YearFormatEnum.NONE,
] as const

export const monthFormats: readonly MonthFormatEnum[] = [
  MonthFormatEnum.MM,
  MonthFormatEnum.M,
  MonthFormatEnum.MMM,
  MonthFormatEnum.MMMM,
  MonthFormatEnum.NONE,
] as const

export const dayFormats: readonly DayFormatEnum[] = [
  DayFormatEnum.DD,
  DayFormatEnum.D,
  DayFormatEnum.NONE,
] as const

export const hourFormats: readonly HourFormatEnum[] = [
  HourFormatEnum.H,
  HourFormatEnum.HH,
  HourFormatEnum.LOWER_H,
  HourFormatEnum.LOWER_HH,
  HourFormatEnum.NONE,
] as const

export const notationOrders: readonly NotationOrderEnum[] = [
  NotationOrderEnum.YMDH,
  NotationOrderEnum.MYDH,
  NotationOrderEnum.MDYH,
  NotationOrderEnum.DMYH,
] as const

export const yearFormatLabel: Record<YearFormatEnum, string> = {
  [YearFormatEnum.YYYY]: '西暦4桁（例：2025）',
  [YearFormatEnum.YY]: '西暦2桁（例：25）',
  [YearFormatEnum.NONE]: 'なし',
}

export const monthFormatLabel: Record<MonthFormatEnum, string> = {
  [MonthFormatEnum.MM]: '数字、0埋めアリ（例：02）',
  [MonthFormatEnum.M]: '数字、0埋めナシ（例：2）',
  [MonthFormatEnum.MMM]: '英語短縮系（例：Feb）',
  [MonthFormatEnum.MMMM]: '英語（例：February）',
  [MonthFormatEnum.NONE]: 'なし',
}

export const dayFormatLabel: Record<DayFormatEnum, string> = {
  [DayFormatEnum.DD]: '0埋めアリ（例：02）',
  [DayFormatEnum.D]: '0埋めナシ（例：2）',
  [DayFormatEnum.NONE]: 'なし',
}

export const hourFormatLabel: Record<HourFormatEnum, string> = {
  [HourFormatEnum.H]: '24時間表記、0埋めナシ（例：9）',
  [HourFormatEnum.HH]: '24時間表記、0埋めアリ（例：09）',
  [HourFormatEnum.LOWER_H]: '12時間表記、0埋めナシ（例：9）',
  [HourFormatEnum.LOWER_HH]: '12時間表記、0埋めアリ（例：09）',
  [HourFormatEnum.NONE]: 'なし',
}

export const notationOrderLabel: Record<NotationOrderEnum, string> = {
  [NotationOrderEnum.YMDH]: '年月日時',
  [NotationOrderEnum.MYDH]: '月年日時',
  [NotationOrderEnum.MDYH]: '月日年時',
  [NotationOrderEnum.DMYH]: '日月年時',
}
